import React, { FC, PropsWithChildren } from 'react'

import cn from 'classnames'

import classes from './panel.module.scss'

export interface PanelProps {
  className?: string
}

// A lightweight container that simply renders its children
export const Panel: FC<PropsWithChildren<PanelProps>> = ({
  children,
  className,
}) => {
  return <div className={cn(classes.panel, className)}>{children}</div>
}
